/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Android_DeviceInputs */

const en_plan_android_device = /** @type {(inputs: Plan_Android_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android device`)
};

const es_plan_android_device = /** @type {(inputs: Plan_Android_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dispositivo Android`)
};

/**
* | output |
* | --- |
* | "Android device" |
*
* @param {Plan_Android_DeviceInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_android_device = /** @type {((inputs?: Plan_Android_DeviceInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Android_DeviceInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_android_device(inputs)
	return en_plan_android_device(inputs)
});